import Vue from 'vue'
import Router from 'vue-router'
import Demo from '@/components/Demo'
import Case from '@/components/Case'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'case',
      component: Case
    },
    {
      path: '/demo',
      name: 'demo',
      component: Demo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js